import { render } from "./ConnectedHeader.vue?vue&type=template&id=661e0fe0"
import script from "./ConnectedHeader.vue?vue&type=script&lang=js"
export * from "./ConnectedHeader.vue?vue&type=script&lang=js"

import exportComponent from "/home/circleci/project/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__